// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__aYBCj {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  min-width: 0; }

.styles_selectableGatewayFeedItem__jvPZA > div:first-child > div:first-child > div:last-child {
  flex-direction: row-reverse; }

.styles_titleContainer__SNe4C {
  height: 3rem;
  align-items: center; }

.styles_container__8UJkm {
  width: 90%;
  margin-top: 2rem; }
  .styles_container__8UJkm > div:first-child {
    margin-bottom: unset;
    cursor: pointer; }
  .styles_container__8UJkm:not(.styles_childFeedItem__ANqOh) {
    height: 5.4rem;
    margin: 1rem auto; }
    .styles_container__8UJkm:not(.styles_childFeedItem__ANqOh) > div:first-child {
      height: 5.4rem;
      max-height: unset; }
  .styles_container__8UJkm > div:not(:first-child) {
    padding: unset; }
  .styles_container__8UJkm .styles_textContainer__VBr1C {
    border: 1px solid #808080b8;
    border-radius: 0.9rem; }

.styles_options__uDDoS {
  width: 100%; }
  .styles_options__uDDoS > div button {
    font-size: 0.72rem;
    padding: 0rem 0.5rem !important;
    margin: 0.25rem; }

.styles_stampIndicator__Rirgl {
  margin: 0rem 1rem;
  display: flex; }
  .styles_stampIndicator__Rirgl svg {
    height: 1.75rem;
    width: 1.75rem; }
  .styles_stampIndicator__Rirgl .styles_completed__Qtwi8 {
    color: #72abab; }
    .styles_stampIndicator__Rirgl .styles_completed__Qtwi8:hover {
      color: purple;
      transform: rotate(0deg); }
  .styles_stampIndicator__Rirgl .styles_dottedCrossHairs__Dcvwk {
    color: #808080b8;
    transition: all 0.5s ease;
    transform: rotate(45deg);
    cursor: pointer; }
    .styles_stampIndicator__Rirgl .styles_dottedCrossHairs__Dcvwk:hover {
      color: #72abab;
      transform: rotate(0deg); }
      .styles_stampIndicator__Rirgl .styles_dottedCrossHairs__Dcvwk:hover:after {
        content: "Complete!";
        font-size: 0.72rem;
        font-weight: 700;
        color: #72abab;
        margin-left: 0.5rem; }
  .styles_stampIndicator__Rirgl .styles_crossHairs__\\+2a0R {
    color: #808080b8;
    transition: all 0.5s ease;
    transform: rotate(45deg);
    cursor: pointer; }
    .styles_stampIndicator__Rirgl .styles_crossHairs__\\+2a0R:hover {
      color: #72abab;
      transform: rotate(0deg); }
    .styles_stampIndicator__Rirgl .styles_crossHairs__\\+2a0R:after {
      content: "Commenced";
      font-size: 0.72rem;
      font-weight: 700;
      color: #72abab;
      margin-left: 0.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/roadmaps/components/RoadmapFeedItem/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,YAAY,EAAA;;AAGd;EAIQ,2BAA2B,EAAA;;AAMnC;EACE,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,UAAU;EACV,gBAAgB,EAAA;EAFlB;IAKI,oBAAoB;IACpB,eAAe,EAAA;EANnB;IAUI,cAAc;IACd,iBAAiB,EAAA;IAXrB;MAcM,cAAc;MACd,iBAAiB,EAAA;EAfvB;IAoBI,cAAc,EAAA;EApBlB;IAwBI,2BChCc;IDiCd,qBAAqB,EAAA;;AAIzB;EACE,WAAW,EAAA;EADb;IAII,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe,EAAA;;AAKnB;EACE,iBAAiB;EACjB,aAAa,EAAA;EAFf;IAKI,eAAe;IACf,cAAc,EAAA;EANlB;IAUI,cCpCgB,EAAA;ID0BpB;MAaM,aAAa;MACb,uBAAuB,EAAA;EAd7B;IAmBI,gBCnEc;IDoEd,yBAAyB;IACzB,wBAAwB;IACxB,eAAe,EAAA;IAtBnB;MAyBM,cCnDc;MDoDd,uBAAuB,EAAA;MA1B7B;QA6BQ,oBAAoB;QACpB,kBAAkB;QAClB,gBAAgB;QAChB,cC1DY;QD2DZ,mBAAmB,EAAA;EAjC3B;IAuCI,gBCvFc;IDwFd,yBAAyB;IACzB,wBAAwB;IACxB,eAAe,EAAA;IA1CnB;MA6CM,cCvEc;MDwEd,uBAAuB,EAAA;IA9C7B;MAkDM,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,cC/Ec;MDgFd,mBAAmB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.selectableGatewayFeedItem {\n  & > div:first-child {\n    & > div:first-child {\n      & > div:last-child {\n        flex-direction: row-reverse;\n      }\n    }\n  }\n}\n\n.titleContainer {\n  height: 3rem;\n  align-items: center;\n}\n\n.container {\n  width: 90%;\n  margin-top: 2rem;\n\n  &>div:first-child {\n    margin-bottom: unset;\n    cursor: pointer;\n  }\n\n  &:not(.childFeedItem) {\n    height: 5.4rem;\n    margin: 1rem auto;\n\n    &>div:first-child {\n      height: 5.4rem;\n      max-height: unset;\n    }\n  }\n\n  &>div:not(:first-child) {\n    padding: unset;\n  }\n\n  .textContainer {\n    border: 1px solid $grey72;\n    border-radius: 0.9rem;\n  }\n}\n\n.options {\n  width: 100%;\n\n  &>div button {\n    font-size: 0.72rem;\n    padding: 0rem 0.5rem !important;\n    margin: 0.25rem;\n  }\n}\n\n\n.stampIndicator {\n  margin: 0rem 1rem;\n  display: flex;\n\n  svg {\n    height: 1.75rem;\n    width: 1.75rem;\n  }\n\n  .completed {\n    color: $ocean_blue;\n\n    &:hover {\n      color: purple;\n      transform: rotate(0deg);\n    }\n  }\n\n  .dottedCrossHairs {\n    color: $grey72;\n    transition: all 0.5s ease;\n    transform: rotate(45deg);\n    cursor: pointer;\n\n    &:hover {\n      color: $ocean_blue;\n      transform: rotate(0deg);\n\n      &:after {\n        content: \"Complete!\";\n        font-size: 0.72rem;\n        font-weight: 700;\n        color: $ocean_blue;\n        margin-left: 0.5rem;\n      }\n    }\n  }\n\n  .crossHairs {\n    color: $grey72;\n    transition: all 0.5s ease;\n    transform: rotate(45deg);\n    cursor: pointer;\n\n    &:hover {\n      color: $ocean_blue;\n      transform: rotate(0deg);\n    }\n\n    &:after {\n      content: \"Commenced\";\n      font-size: 0.72rem;\n      font-weight: 700;\n      color: $ocean_blue;\n      margin-left: 0.5rem;\n    }\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__aYBCj`,
	"selectableGatewayFeedItem": `styles_selectableGatewayFeedItem__jvPZA`,
	"titleContainer": `styles_titleContainer__SNe4C`,
	"container": `styles_container__8UJkm`,
	"childFeedItem": `styles_childFeedItem__ANqOh`,
	"textContainer": `styles_textContainer__VBr1C`,
	"options": `styles_options__uDDoS`,
	"stampIndicator": `styles_stampIndicator__Rirgl`,
	"completed": `styles_completed__Qtwi8`,
	"dottedCrossHairs": `styles_dottedCrossHairs__Dcvwk`,
	"crossHairs": `styles_crossHairs__+2a0R`
};
export default ___CSS_LOADER_EXPORT___;
